var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"button",class:( _obj = {'button--light': _vm.light}, _obj[("button--" + _vm.size)] = true, _obj['button--active'] =  _vm.active, _obj ),attrs:{"role":"button"},on:{"click":function($event){_vm.clickHandler; _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }